import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AttachmentUploadStatus} from '../attachments.interface';


interface UploadStatus extends Omit<AttachmentUploadStatus, 'uploadUrl'> {}


@Component({
  selector: 'app-attachment-status',
  templateUrl: './attachment-status.component.html',
  styleUrls: ['./attachment-status.component.scss'],
  standalone: false
})
export class AttachmentStatusComponent {
  @Input() showItemCancel = false;
  @Input() isFileClickable = false;
  @Input() uploadStatus: UploadStatus;
  @Input() showProgressWhileAssociating = true;
  @Output() removeEvent = new EventEmitter();
  @Output() fileClickEvent = new EventEmitter();

  onCancelClick() {
    this.removeEvent.emit();
  }

  onFileClick() {
    this.fileClickEvent.emit();
  }
}
